import React, { useState, useCallback } from "react";
import {
  setLoggedinUser,
  useCirclePlugLogin,
  useInitOtp,
} from "../../lib/util";
import { useAppDispatch } from "../slice/hooks";
import { logInUser } from "../slice/auth-slice";
import { brandlogo, internationalCodes } from "../../assets";

const LoginForm = ({ onBack, setShowLogin, onLoginSuccess, fromChat }) => {
  const dispatch = useAppDispatch();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCode, setSelectedCode] = useState("+1");
  const [error, setError] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [loginType, setLoginType] = useState("email"); // "email" or "phone"

  const { isLoading: isLoginLoading, mutate: loginMutate } = useCirclePlugLogin(
    {
      onError: (response) => {
        setError(response.message);
      },
      onSuccess: async (response) => {
        const { user, token, tokenExpiryDate, tokenType, sessionId } =
          response.data;
        if (tokenType === "login") {
          const loggedInUser = {
            sessionId,
            tokenExpiryDate,
            token,
            user: user,
          };
          setLoggedinUser(loggedInUser);
          dispatch(logInUser({ loggedInUser, authenticated: true, token }));
          onLoginSuccess(tokenType, sessionId, token, loggedInUser);
          onBack();
        } else if (tokenType === "otp") {
          const { trackId, identifier, name, type, waitTime } = response.data;
          onLoginSuccess(
            tokenType,
            sessionId,
            token,
            null,
            { trackId, tokenExpiryDate, identifier, name, type, waitTime },
            "login",
          );
        }
      },
    },
  );

  const { isLoading: isForgotPasswordLoading, mutate: mutateInitOtp } =
    useInitOtp({
      onError: (response) => {
        setError(response.message);
      },
      onSuccess: (response) => {
        const {
          tokenType,
          token,
          trackId,
          identifier,
          name,
          type,
          waitTime,
          sessionId,
          tokenExpiryDate,
        } = response.data;
        onLoginSuccess(
          tokenType,
          sessionId,
          token,
          null,
          { trackId, tokenExpiryDate, identifier, name, type, waitTime },
          "password",
        );
      },
    });

  const togglePasswordVisibility = useCallback(() => {
    setPasswordVisible((prev) => !prev);
  }, []);

  const handlePasswordChange = useCallback((e) => {
    setPassword(e.target.value);
    setError("");
  }, []);

  const handleEmailChange = useCallback((e) => {
    setEmail(e.target.value);
    setError("");
  }, []);

  const handlePhoneNumberChange = useCallback((e) => {
    setPhoneNumber(e.target.value);
    setError("");
  }, []);

  const handleCodeChange = useCallback((e) => {
    setSelectedCode(e.target.value);
    setError("");
  }, []);

  const handleLoginSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (loginType === "email") {
        loginMutate({ identifier: email, secret: password, type: loginType });
      } else if (loginType === "mobile") {
        loginMutate({
          identifier: `${selectedCode}${phoneNumber}`,
          secret: password,
          type: loginType,
        });
      }
    },
    [email, password, phoneNumber, selectedCode, loginType, loginMutate],
  );

  const handleForgotPasswordSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (loginType === "email") {
        mutateInitOtp({
          target: "password",
          identifier: email,
          type: loginType,
        });
      } else if (loginType === "mobile") {
        mutateInitOtp({
          target: "password",
          identifier: `${selectedCode}${phoneNumber}`,
          type: loginType,
        });
      }
    },
    [email, phoneNumber, selectedCode, loginType, mutateInitOtp],
  );

  const handleForgotPassword = useCallback(() => {
    setShowForgotPassword(true);
  }, []);

  return (
    <div className="auth-form-container auth-form-container-login">
      {showForgotPassword ? (
        <>
          {/* <h2>Forgot Password</h2> */}
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleForgotPasswordSubmit}>
            <div className="auth-toggle tab">
              <span
                className={`auth-toggle-option ${
                  loginType === "email" ? "active" : ""
                }`}
                onClick={() => setLoginType("email")}
              >
                Email
              </span>
              <span
                className={`auth-toggle-option ${
                  loginType === "mobile" ? "active" : ""
                }`}
                onClick={() => setLoginType("mobile")}
              >
                Phone number
              </span>
            </div>
            {loginType === "email" ? (
              <div className="input-box">
                <label htmlFor="forgot-email">Email:</label>
                <div className="input-text">
                  <input
                    type="email"
                    id="forgot-email"
                    name="forgot-email"
                    value={email}
                    onChange={handleEmailChange}
                    required
                    placeholder="Enter your email"
                  />
                </div>
              </div>
            ) : (
              <div className="input-box">
                <label htmlFor="forgot-phone">Phone Number:</label>
                <div className="input-text">
                  <select
                    id="forgot-code"
                    name="forgot-code"
                    value={selectedCode}
                    onChange={handleCodeChange}
                    required
                  >
                    {internationalCodes.map((code) => (
                      <option key={code.code} value={code.code}>
                        {code.code} ({code.countryCode})
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    id="forgot-phone"
                    name="forgot-phone"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    required
                    placeholder="Enter your phone number"
                  />
                </div>
              </div>
            )}
            <div className="login-container">
              <button
                type="submit"
                className="auth-submit-button"
                disabled={isForgotPasswordLoading}
              >
                {isForgotPasswordLoading ? "Sending..." : "Send Reset Link"}
              </button>
            </div>
          </form>
          <p
            className="forgot-password-link"
            onClick={() => setShowForgotPassword(false)}
          >
            Back to Login
          </p>
        </>
      ) : (
        <>
          {/* {!fromChat && (
            <div className={styles.brandImagecontainer} onClick={handleClick}>
              <Image
                src={brandlogo}
                alt="circle plug brand logo"
                className={styles.brandlogo}
                quality={1}
              />
            </div>
          )} */}
          {!fromChat && <h2>Welcome Back</h2>}
          {!fromChat && <h4>Sign in to your account and continue shopping</h4>}
          {error && <div className="error-message">{error}</div>}
          <div className="input-container">
            <form onSubmit={handleLoginSubmit}>
              <div className="auth-toggle tab">
                <span
                  className={`auth-toggle-option ${
                    loginType === "email" ? "active" : ""
                  }`}
                  onClick={() => setLoginType("email")}
                >
                  Email
                </span>
                <span
                  className={`auth-toggle-option ${
                    loginType === "mobile" ? "active" : ""
                  }`}
                  onClick={() => setLoginType("mobile")}
                >
                  Phone number
                </span>
              </div>
              {loginType === "email" ? (
                <div className="input-box">
                  <label htmlFor="email">Email:</label>
                  <div className="input-text">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={handleEmailChange}
                      required
                      placeholder="Email"
                    />
                  </div>
                </div>
              ) : (
                <div className="input-box">
                  <label htmlFor="phone">Phone Number:</label>
                  <div className="input-text">
                    <select
                      id="code"
                      name="code"
                      value={selectedCode}
                      onChange={handleCodeChange}
                      required
                    >
                      {internationalCodes.map((code) => (
                        <option key={code.code} value={code.code}>
                          {code.code} ({code.countryCode})
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      required
                      placeholder="Enter your phone number"
                    />
                  </div>
                </div>
              )}
              <div className="input-box">
                <label htmlFor="password">Password:</label>
                <div className="input-text">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    id="password"
                    name="password"
                    value={password}
                    onChange={handlePasswordChange}
                    required
                    placeholder="Password"
                    autocomplete="off"
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={togglePasswordVisibility}
                    aria-label={
                      passwordVisible ? "Hide password" : "Show password"
                    }
                  >
                    <i
                      className={`fa ${
                        passwordVisible ? "fa-eye-slash" : "fa-eye"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </div>
              <div className="login-container">
                <button
                  type="submit"
                  className="auth-submit-button"
                  disabled={isLoginLoading}
                >
                  {isLoginLoading ? "Signing in..." : "Sign"}
                </button>
              </div>
            </form>

            <div className="login-container">
              <span
                className="auth-secondary-button"
                onClick={() => setShowLogin(false)}
              >
                Create Account
              </span>
            </div>
          </div>
          <p className="forgot-password-link" onClick={handleForgotPassword}>
            Forgot Password?
          </p>
        </>
      )}
    </div>
  );
};

export default LoginForm;
